import { render, staticRenderFns } from "./NewPaymentFields.vue?vue&type=template&id=22392283&scoped=true"
import script from "./NewPaymentFields.vue?vue&type=script&lang=js"
export * from "./NewPaymentFields.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentFields.vue?vue&type=style&index=0&id=22392283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22392283",
  null
  
)

export default component.exports